export const FIELD_TYPES = [
    { value: 'text', label: 'Text' },
    { value: 'textarea', label: 'Long Text' },
    { value: 'number', label: 'Number' },
    { value: 'select', label: 'Select' },
    { value: 'multiselect', label: 'Multi-select' },
    { value: 'date', label: 'Date' },
    { value: 'boolean', label: 'Yes/No' }
];
export const NAMESPACE = 'features.settings.component_types';
/**
 * Creates a new empty field definition with default values
 */
export const createNewField = () => ({
    key: `field_${Date.now()}`,
    label: '--',
    type: 'text',
    required: false
});
/**
 * Generates a snake_case key from a label string
 */
export const generateKeyFromLabel = (label) => label
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
/**
 * Parses comma-separated options string into array
 */
export const parseOptionsString = (optionsString) => optionsString
    .split(',')
    .map((opt) => opt.trim())
    .filter((opt) => opt.length > 0);
/**
 * Adds a new field to the field definitions array
 */
export const addField = (fieldDefinitions) => [
    ...fieldDefinitions,
    createNewField()
];
/**
 * Removes a field at the specified index
 */
export const removeField = (fieldDefinitions, index) => fieldDefinitions.filter((_, i) => i !== index);
/**
 * Updates a field at the specified index with the given updates
 * When type changes, clears type-specific fields and adds required defaults
 */
export const updateField = (fieldDefinitions, index, updates) => fieldDefinitions.map((field, i) => {
    if (i !== index)
        return field;
    // When type changes, clear type-specific fields and add required defaults
    if (updates.type && updates.type !== field.type) {
        const baseField = {
            key: field.key,
            label: field.label,
            type: updates.type,
            required: field.required
        };
        // Add default empty options array for select/multiselect types
        if (updates.type === 'select' || updates.type === 'multiselect') {
            return Object.assign(Object.assign({}, baseField), { options: ['--'] });
        }
        return baseField;
    }
    return Object.assign(Object.assign({}, field), updates);
});
/**
 * Determines if a field type needs options input (select/multiselect)
 */
export const needsOptions = (fieldType) => fieldType === 'select' || fieldType === 'multiselect';
/**
 * Determines if a field type needs min/max input (number)
 */
export const needsMinMax = (fieldType) => fieldType === 'number';
/**
 * Determines if a field type needs max length input (text/textarea)
 */
export const needsMaxLength = (fieldType) => fieldType === 'text' || fieldType === 'textarea';
/**
 * Gets the required extra fields for a given field type
 */
export const getFieldTypeRequirements = (fieldType) => ({
    needsOptions: needsOptions(fieldType),
    needsMinMax: needsMinMax(fieldType),
    needsMaxLength: needsMaxLength(fieldType)
});
